<nav>
  @for (step of stepArray; track step) {
    <span class="step-circle" [ngClass]="{'active': (currentStep | async) === step}"></span>
  }
</nav>
